import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { IconCheckCircle, IconXCircle } from './Icons';

const ConfirmEmailScreen = ({ token, apiBaseUrl, onBackToLogin, onConfirmed }) => {
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('Проверка токена...');
  const [accessCode, setAccessCode] = useState(null);
  const [userEmail, setUserEmail] = useState(null);

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/api/auth/confirm/${token}`);
        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.message);
          // Сохраняем email для автозаполнения
          if (response.data.email) {
            setUserEmail(response.data.email);
          }
          // Если email не отправлен, показываем код доступа напрямую
          if (response.data.access_code) {
            setAccessCode(response.data.access_code);
          }
        } else {
          setStatus('error');
          setMessage(response.data.error || 'Ошибка подтверждения');
        }
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Произошла ошибка при подтверждении email');
      }
    };

    if (token) {
      confirmEmail();
    }
  }, [token, apiBaseUrl]);

  return (
    <div className="login-container" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      maxWidth: '500px',
      margin: '0 auto',
      padding: '40px',
      backgroundColor: 'var(--panel)',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
      textAlign: 'center'
    }}>
      <h2 style={{ marginBottom: '20px' }}>Подтверждение Email</h2>
      
      {status === 'verifying' && (
        <div style={{ color: '#64b5f6' }}>
          <div className="spinner" style={{ marginBottom: '15px' }}></div>
          <p>{message}</p>
        </div>
      )}

      {status === 'success' && (
        <div style={{ color: '#28a745' }}>
          <div style={{ marginBottom: '15px' }}><IconCheckCircle size={48} /></div>
          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>Готово!</p>
          <p>{message}</p>
          {accessCode && (
            <div style={{ 
              marginTop: '20px', 
              padding: '15px', 
              backgroundColor: 'var(--panel-2)', 
              borderRadius: '8px',
              border: '2px dashed #28a745'
            }}>
              <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>Ваш код доступа:</p>
              <p style={{ 
                fontSize: '24px', 
                fontWeight: 'bold', 
                color: '#64b5f6',
                letterSpacing: '2px'
              }}>
                {accessCode}
              </p>
              <p style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '10px' }}>
                Сохраните этот код! Он понадобится для входа.
              </p>
            </div>
          )}
          <button 
            onClick={() => {
              // Передаем email для автозаполнения
              if (onConfirmed && userEmail) {
                onConfirmed(userEmail);
              } else {
                onBackToLogin();
              }
            }}
            style={{
              marginTop: '20px',
              padding: '12px 24px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            Вернуться ко входу
          </button>
        </div>
      )}

      {status === 'error' && (
        <div style={{ color: '#dc3545' }}>
          <div style={{ marginBottom: '15px' }}><IconXCircle size={48} /></div>
          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>Ошибка</p>
          <p>{message}</p>
          <button 
            onClick={onBackToLogin}
            style={{
              marginTop: '20px',
              padding: '12px 24px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
          >
            На главную
          </button>
        </div>
      )}
    </div>
  );
};

export default ConfirmEmailScreen;
